@if (!missingEmbedReason() && workflowUrl(); as url) {
  @if (hasUpdate()) {
    <div class="tt-edit-workflow-widget_update-notification">
      <div class="tt-edit-workflow-widget_update-notification-banner">
        <tt-banner
          [icon]="'info'"
          [message]="
            'WorkflowWidget.UpdateBanner' | transloco: { oldVersion: widget().workflowVersion, newVersion: widget().latestVersion }
          "
          [type]="'neutral'" />
      </div>
    </div>
  }
  <div class="tt-workflow-widget_iframe-container">
    <iframe
      #workflowFrame
      allow="local-network-access *"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
      [src]="url"></iframe>
  </div>
} @else {
  <tt-no-results [icon]="'file-x-2'" [size]="'small'" [title]="'WorkflowWidget.EmbedNotAvailable'" />
}
